import React, { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../Loading";

const SearchBox = ({ className = "", mainData, getValue, changeObj, get }) => {
  const navigate = useNavigate();
  const { citySlug } = useParams();

  if (!mainData?.cities) {
    return (
      <div className={`search-box p-2 ${className || ""}`}>
        <Loading />
      </div>
    );
  }
  return (
    <div className={`search-box ${className || ""}`}>
      <div className="searchtem_Box">
        <select
          onChange={({ target: { value } }) => {
            navigate("/ads/" + value);
          }}
          value={citySlug || ""}
        >
          <option>شهر مورد نظر را انتخاب کنید</option>
          {mainData.cities.map(city => {
            return (
              <>
                <option key={city.id} value={city.slug}>
                  {city.title}
                </option>
              </>
            );
          })}
        </select>
        <span className="selectChevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg></span>
      </div>
      <div className="searchtem_Box">
        <select
          onChange={({ target: { value } }) => {
            // setForm({ ...form, category_id: value });
            changeObj("category_parent_id", value);
          }}
          value={getValue("category_parent_id") || ""}
        >
          <option>دسته بندی مورد نظر را انتخاب کنید</option>
          {mainData.categories.map(cat => {
            return (
              <option value={cat.id} key={cat.id}>
                {cat.title}
              </option>
            );
          })}
        </select>
        <span className="selectChevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg></span>
      </div>

      <button onClick={get}>
        <BiSearch size={"1.5rem"} />
        <span>جست و جو</span>
      </button>
    </div>
  );
};

export default SearchBox;
